import { createApiRef } from '@backstage/core-plugin-api';

import {
  ExternalUser,
} from '../utils/utils';

export interface ExternalUsersListParams {
  service?: string;
  company?: string;
}

// =====================================
// CREATE
// =====================================

export interface CreateExternalUserPayload {
  mail: string;

  firstname: string;

  lastname: string;

  sponsor: string;

  company: string;

  whenExpired: string;

  service: string;
}

// =====================================
// UPDATE
// =====================================

export interface UpdateExternalUserPayload {
  firstname?: string;

  lastname?: string;

  sponsor?: string;

  company?: string;

  whenExpired?: string;

  add_service?: string;

  remove_service?: string;
}

// =====================================
// GENERIC API RESPONSE
// =====================================

export interface ApiMessageResponse {
  mail: string;

  message: string;
}

// =====================================
// API CONTRACT
// =====================================

export interface ExternalUsersApi {
  list(params?: ExternalUsersListParams): Promise<ExternalUser[]>;

  getById(
    objectid: string,
  ): Promise<ExternalUser>;

  getByMail(mail: string): Promise<ExternalUser | null>;

  create(
    payload: CreateExternalUserPayload,
  ): Promise<ApiMessageResponse>;

  update(
    objectid: string,

    payload: UpdateExternalUserPayload,
  ): Promise<ApiMessageResponse>;

  delete(
    objectid: string,
  ): Promise<ApiMessageResponse>;
}

// =====================================
// API REF
// =====================================

export const externalUsersApiRef =
  createApiRef<ExternalUsersApi>({
    id: 'plugin.external-onboarding.service',
  });